// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__i1iUk","tab":"Tabs_tab__7+B4j","activeTab":"Tabs_activeTab__XPR4p","badge":"Tabs_badge__aD0l-"};